import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-dialog-popup',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss']
})
export class DialogModalComponent implements OnInit {

  @Input() modalTitle;
  @Input() modalText: string;
  @Input() confirmText = 'Evet';
  @Input() noButton = true;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/dialog-modal/dialog-modal.component.ts